import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import numeral from 'numeral';
import { H5, H6 } from '../Typography';
import { getRoomDataForRender } from '../../../src/utils/stat-utils';

const Container = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-auto-flow: column;

  div:nth-child(-n+3) {
    border-right: 1px solid #ebebeb;
  }
  div:nth-child(3n+1) {
    background-color: #ffffff;
    * {
      color: #666666;
    }
  }

  div:nth-child(3n+2) {
    background-color: #ed8747;
    * {
      color: #702b00;
    }
  }
  div:nth-child(3n+3) {
    background-color: #d4bd79;
    * {
      color: #4d3b08;
    }
  }
`;

const Info = styled.div`
  height: 100%;
  max-height: 36px;
  box-sizing: border-box;
  background-color: pink;
  padding: 8px 10px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const TextPrice = styled(H5)`
  font-size: 0.75rem !important;
  text-transform: uppercase;
`;

const TextTitle = styled(H6)`
  font-size: 0.75rem !important;
`;

const formatNumber = (value) => {
  if (_.isNaN(value) || _.isUndefined(value) || value === 0) return 'N/A'
  return numeral(value).format('0,0.00a');
}

export default class extends React.PureComponent {
  
  render() {
    const {
      rooms
    } = this.props;
    const avgRoomData = getRoomDataForRender(rooms, [
      { key: 'resalePriceSqm', mode: 'avg' }, 
      { key: 'rentalPriceSqm', mode: 'avg' }, 
      { key: 'startingPrice', mode: 'min' }, 
      { key: 'startingResalePrice', mode: 'min' }, 
      { key: 'capitalGain', mode: 'avg' }, 
      { key: 'rentalYield', mode: 'avg' }
    ]);

    const avgRoomData2 = getRoomDataForRender(rooms, [
      { key: 'resalePriceSqm', mode: 'min' }, // TODO
    ]);
    return (
      <Container>
        <Info>
          <TextTitle>Starting Price (sq.m.)</TextTitle>
          <TextPrice>{formatNumber(_.get(avgRoomData2, 'resalePriceSqm'))}</TextPrice>
        </Info>
        <Info>
          <TextTitle>Sale (sq.m.)</TextTitle>
          <TextPrice>{formatNumber(_.get(avgRoomData, 'resalePriceSqm'))}</TextPrice>
        </Info>
        <Info>
          <TextTitle>Rent (sq.m.)</TextTitle>
          <TextPrice>{formatNumber(_.get(avgRoomData, 'rentalPriceSqm'))}</TextPrice>
        </Info>
        <Info>
          <TextTitle>Starting Price</TextTitle>
          <TextPrice>{formatNumber(_.get(avgRoomData, 'startingResalePrice'))}</TextPrice>
        </Info>
        <Info>
          <TextTitle>Capital Gain</TextTitle>
          <TextPrice>{formatNumber(_.get(avgRoomData, 'capitalGain'))}</TextPrice>
        </Info>
        <Info>
          <TextTitle>Rental Yield</TextTitle>
          <TextPrice>{formatNumber(_.get(avgRoomData, 'rentalYield'))}</TextPrice>
        </Info>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StatDetail/resale.js